import React from 'react';
import { Container } from './Checkbox.styles';
import { ReactComponent as CheckboxIcon } from '../../../assets/icons/check.svg';
import { ReactComponent as CheckboxEmptyIcon } from '../../../assets/icons/check-empty.svg';
import { Text12Light } from '../Text/Text.styles';

const Checkbox = ({ disabled, value, onChange, label }) => {
  return (
    <Container
      onClick={() => {
        if (!disabled) {
          onChange(!value);
        }
      }}>
      <Text12Light>{label}</Text12Light>
      {value ? <CheckboxIcon width={20} height={20} /> : <CheckboxEmptyIcon width={20} height={20} />}
    </Container>
  );
};

export default Checkbox;
